import HTTPService from "../utility/httpService";
import { keyConstants, apiEndPointConstants } from "../constants";
import Utils from "../utility";
const { TOKEN } = keyConstants;
const {
  REWARD,
  COUPON,
  COUPONS,
  BUSINESS,
  USER_COUPON,
  MARKETING_USERS,
  MARKETING_DISCOUNTS,
  PARTNER_COUPON,
  PARTNER_COUPONS,
  CATEGORIES_MERCHANTS
} = apiEndPointConstants;

export default class RewardsService {
  /**
   * Initializes a new instance of the class.
   *
   * @constructor
   */
  constructor(token) {
    this.httpService = new HTTPService(
      process.env.REACT_APP_REWARD_MICROSERVICE
    );
    this.config = {
      headers: {
        Authorization: `Bearer ${
          token !== undefined ? token : Utils.cookieGetItem(TOKEN)?.access_token
        }`,
        "X-Api-Key": process.env.REACT_APP_X_API_KEY
      }
    };
  }

  /**
   * Retrieves the reward by business ID.
   *
   * @param {number} businessId - The ID of the business.
   * @return {Promise} A promise that resolves to the reward data.
   */
  getRewardByBusinessId(businessId) {
    const url = `${REWARD}/${businessId}`;
    const requestData = {};

    return this.httpService.get(url, requestData, this.config);
  }
  /**
   * Adds a reward.
   *
   * @param {type} requestData - the request data for adding the reward
   * @return {type} - the result of the HTTP POST request
   */
  addReward(requestData) {
    const url = `${REWARD}`;

    return this.httpService.post(url, requestData, this.config);
  }

  /**
   * Updates the reward.
   *
   * @param {Object} requestData - The data for the request.
   * @return {Promise} A promise that resolves with the updated reward.
   */
  updateReward(requestData) {
    const url = `${REWARD}`;

    return this.httpService.put(url, requestData, this.config);
  }

  /**
   * Retrieves marketing users based on business ID and key.
   *
   * @param {Object} requestData - The request data containing businessId and key.
   * @return {Promise} A promise that resolves to the marketing users data.
   */
  getMarketingUsers(requestData) {
    const {
      businessId,
      searchQuery,
      discount,
      startTime,
      endTime,
      sortingKey,
      skip = 0,
      limit = 10
    } = requestData;

    let url = `${MARKETING_USERS}?businessId=${businessId}&searchQuery=${searchQuery}&sortingKey=${sortingKey}&skip=${skip}&limit=${limit}`;

    // Append discount, startTime, and endTime if they are not null
    if (discount !== null) {
      url += `&discountValue=${discount}`;
    }
    if (startTime !== null) {
      url += `&startTime=${startTime}`;
    }
    if (endTime !== null) {
      url += `&endTime=${endTime}`;
    }

    return this.httpService.get(url, {}, this.config);
  }

  getUserCoupon({ business, sortingKey, skip = 0, limit = 10 }) {
    const url = `${USER_COUPON}`;
    const requestData = { business, sortingKey, skip, limit };
    return this.httpService.get(url, requestData, this.config);
  }

  getCouponsByBusinessId(businessId, skip = 0, limit = 5) {
    const url = `${BUSINESS}/${businessId}${COUPONS}?skip=${skip}&limit=${limit}`;
    const requestData = {};
    return this.httpService.get(url, requestData, this.config);
  }

  /**
   * Adds a coupon.
   *
   * @param {type} requestData - the request data for adding the coupon
   * @return {type} - the result of the HTTP POST request
   */
  addCoupon(requestData) {
    const url = `${COUPON}`;

    return this.httpService.post(url, requestData, this.config);
  }

  /**
   * Deletes a coupon.
   *
   * @param {type} requestData - the request data for deleteing the coupon
   * @return {type} - the result of the HTTP POST request
   */
  deleteCoupon(requestData) {
    const url = `${COUPON}`;

    return this.httpService.delete(url, requestData, this.config);
  }

  updateCoupon(requestData) {
    const url = `${COUPON}`;

    return this.httpService.put(url, requestData, this.config);
  }

  getMarketingDiscounts(businessId) {
    const url = `${MARKETING_DISCOUNTS}/${businessId}`;
    return this.httpService.get(url, {}, this.config);
  }

  getCategoriesAndMerchants() {
    const url = PARTNER_COUPONS + CATEGORIES_MERCHANTS;
    const requestData = {};
    return this.httpService.get(url, requestData, this.config);
  }

  getPartnerCouponsByBusinessId(businessId, skip = 0, limit = 5) {
    const url = `${BUSINESS}/${businessId + PARTNER_COUPONS}?skip=${skip}&limit=${limit}`;
    const requestData = {};
    return this.httpService.get(url, requestData, this.config);
  }

  addPartnerCoupon(requestData) {
    const url = PARTNER_COUPONS;

    return this.httpService.post(url, requestData, this.config);
  }

  updatePartnerCoupon(requestData) {
    const url = PARTNER_COUPONS;

    return this.httpService.put(url, requestData, this.config);
  }

  deletePartnerCoupon(requestData) {
    const url = PARTNER_COUPON;

    return this.httpService.delete(url, requestData, this.config);
  }
}
